import UpgradeModule from './UpgradeModule'

export default UpgradeModule
